/**
 * fighterBuffReadability — Passive/buff state for fighter wave HUD/VFX (SPY-112).
 */
import {
  DARIUS_HEMORRHAGE_MAX_STACKS
} from './darius.js';
import { SETT_GRIT_MAX_RATIO } from './sett.js';
import { JAX_RELENTLESS_MAX_STACKS } from './jax.js';

export const FIGHTER_BUFF_PASSIVE_IDS = [
  'hemorrhage',
  'pit_grit',
  'relentless_assault'
];

export function listFighterBuffPassiveIds() {
  return [...FIGHTER_BUFF_PASSIVE_IDS];
}

function champKey(entity) {
  return String(entity?.championKey || entity?.name || '').toLowerCase();
}

function dariusReadability(entity) {
  const stacks = entity.hemorrhageStacks || 0;
  return {
    key: 'darius',
    passiveId: 'hemorrhage',
    color: 0xb91c1c,
    stacks,
    maxStacks: DARIUS_HEMORRHAGE_MAX_STACKS,
    empowered: Boolean(entity.noxianMightActive),
    fill: Math.min(1, stacks / DARIUS_HEMORRHAGE_MAX_STACKS)
  };
}

function settReadability(entity) {
  const maxGrit = (entity.maxHp || 1) * SETT_GRIT_MAX_RATIO;
  const grit = entity.grit || 0;
  return {
    key: 'sett',
    passiveId: 'pit_grit',
    color: 0xea580c,
    stacks: Math.round(grit),
    maxStacks: Math.round(maxGrit),
    empowered: grit >= maxGrit * 0.8,
    fill: maxGrit > 0 ? Math.min(1, grit / maxGrit) : 0
  };
}

function jaxReadability(entity) {
  const stacks = entity.relentlessStacks || 0;
  return {
    key: 'jax',
    passiveId: 'relentless_assault',
    color: 0xa855f7,
    stacks,
    maxStacks: JAX_RELENTLESS_MAX_STACKS,
    empowered: Boolean(entity.grandmasterActive || entity.counterStrikeActive),
    fill: Math.min(1, stacks / JAX_RELENTLESS_MAX_STACKS)
  };
}

/**
 * @returns {null | {
 *   key: string,
 *   passiveId: string,
 *   color: number,
 *   stacks: number,
 *   maxStacks: number,
 *   empowered: boolean,
 *   fill: number
 * }}
 */
export function getFighterBuffReadability(entity) {
  if (!entity) return null;
  const key = champKey(entity);
  if (key === 'darius') return dariusReadability(entity);
  if (key === 'sett') return settReadability(entity);
  if (key === 'jax') return jaxReadability(entity);
  return null;
}
